var React = require('react');

function GlassCitrus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 144c0 78.32-62.61 141.73-140.48 143.64l4.85-48.49c49-4.31 87.63-45.08 87.63-95.15a96.11 96.11 0 0 0-96-96c-35.37 0-66 19.45-82.64 48h-52.54C252.65 40.2 305.39 0 368 0a144 144 0 0 1 144 144zM256 448l20.57-192H73.23L93.8 448z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M283.43 192L256 448H93.8L66.37 192h217.06m34.37-64H32a32 32 0 0 0-32 32c0 .67 0 1.33.06 2l32 320A32 32 0 0 0 64 512h221.8a32 32 0 0 0 31.94-30l32-320a32 32 0 0 0-29.93-33.94c-.68 0-1.35-.06-2.01-.06z","className":"fa-primary","key":2})]);
}

GlassCitrus.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GlassCitrus;

GlassCitrus.default = GlassCitrus;
